import type { NodeSn } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { makeMemoizedGetNestedObjectKeys } from 'utils/memoize/makeMemoizedGetObjectKeys';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectPathLookupPathInspectorSelectedNodeSns: (
  s: GraphState,
) => NodeSn[] = createScopedSelector(() =>
  makeMemoizedGetNestedObjectKeys(
    prop('pathlookup', 'pathInspector', 'selectedPackets'),
  ),
);
